// deps
import React, { memo, ReactElement, useMemo } from "react";

// internal deps
import { isEmpty, ScreenReaderOnly } from "@swiggy-private/core-ui";

// components
import { BenefitsItem } from "@cart-ui/components/benefits-item";

export interface BenefitsItemListProps {
    list: { title: string; subTitle?: string; subTextNode?: ReactElement }[];
    className?: string;
}

const ACCESSIBILITY_TEXT = "Benefits applied are: ";

const BenefitsItemList: React.FC<BenefitsItemListProps> = ({ list, className }: BenefitsItemListProps) => {
    const accessibilityText = useMemo(() => {
        let text = ACCESSIBILITY_TEXT;

        list?.forEach(benefit => {
            text += `${benefit.title} ${benefit.subTitle}. `;
        });
        return text;
    }, [list]);

    if (isEmpty(list)) {
        return null;
    }

    return (
        <div className={className}>
            <ScreenReaderOnly text={accessibilityText} />
            {list.map(benefit => (
                <BenefitsItem
                    key={benefit.title}
                    title={benefit.title}
                    subtitle={benefit.subTitle}
                    subTextNode={benefit.subTextNode}
                />
            ))}
        </div>
    );
};

export default memo(BenefitsItemList);
